import { jsx as t } from "react/jsx-runtime";
import { $ as s } from "../../vendor-Blw3V4C-.js";
function p({ children: a, ...e }) {
  const { visuallyHiddenProps: i } = s(), o = {
    polite: "status",
    assertive: "alert"
  }, r = e["aria-live"] ?? "polite";
  return /* @__PURE__ */ t("span", { role: o[r], "aria-live": r, ...i, children: a });
}
export {
  p as AriaLive
};
//# sourceMappingURL=index.js.map
